var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 22.75H5A3.754 3.754 0 0 1 1.25 19V9A3.754 3.754 0 0 1 5 5.25h14A3.755 3.755 0 0 1 22.75 9v10A3.755 3.755 0 0 1 19 22.75zm-14-16A2.252 2.252 0 0 0 2.75 9v10A2.252 2.252 0 0 0 5 21.25h14A2.253 2.253 0 0 0 21.25 19V9A2.253 2.253 0 0 0 19 6.75z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.932 17.622A1.794 1.794 0 0 1 9.14 15.83v-3.66a1.791 1.791 0 0 1 2.593-1.6l3.136 1.568a1.792 1.792 0 0 1 .194 3.093l-3.138 2.089a1.782 1.782 0 0 1-.993.302zm0-5.745a.3.3 0 0 0-.153.045.285.285 0 0 0-.138.248v3.66a.292.292 0 0 0 .453.242l3.137-2.091a.28.28 0 0 0 .129-.26.284.284 0 0 0-.161-.244l-3.137-1.567a.285.285 0 0 0-.131-.033zM12 6.75a.744.744 0 0 1-.53-.22l-4-4a.75.75 0 0 1 1.06-1.06L12 4.939l3.47-3.469a.75.75 0 0 1 1.06 1.06l-4 4a.744.744 0 0 1-.53.22z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.71979e7774651cc847d8fb2f0c41824c.svg";
export { ForwardRef as ReactComponent };